import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { FlightDetailsModalProps } from "./types";
import {
  DivFooterModalBackground,
  DivFooterModal,
  FlightDetailsModalHeaderMobile,
  FieldSearchMobile,
  FlightDetailsModalModalContent,
  FlightDetailsModalModalHeader,
  IconContent,
  InfoContent,
  FlightDetailsModalModalFooter,
} from "./styles";
import { Button } from "Components/atoms/Button";
import { FaArrowLeft } from "react-icons/fa";
import { FlightsFilter } from "Components/organisms/FlightsFilter/Mobile";
import { theme } from "styles/theme";
import { Typography } from "Components/atoms/Typography";
import { GroupButton } from "Components/atoms/GroupButton";

export const FlightDetailsModal: React.FC<FlightDetailsModalProps> = ({
  isVisibleModal,
  onClose,
  children,
}) => {
  const previousScrollYRef = useRef<number>(0);
  const sellerRef = useRef<HTMLDivElement>(null);
  const [selected, setSelected] = useState("aplicar");
  const [filterAction, setFilterAction] = useState<
    "apply" | "clean" | "default"
  >("default");

  const options = [
    { label: "Limpar", value: "limpar" },
    { label: "Aplicar", value: "aplicar" },
  ];

  const handleIsVisible = () => {
    onClose();
  };

  useEffect(() => {
    if (!isVisibleModal) return;

    const scrollY = window.scrollY;
    previousScrollYRef.current = scrollY;
    const previousOverflow = document.body.style.overflow;
    const previousPosition = document.body.style.position;
    const previousTop = document.body.style.top;
    const previousWidth = document.body.style.width;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.position = previousPosition;
      document.body.style.top = previousTop;
      document.body.style.width = previousWidth;
      window.scrollTo(0, previousScrollYRef.current);
    };
  }, [isVisibleModal]);

  const onFilterAction = (value: string) => {
    setSelected(value);
    if (value === "apply" || value === "clean") {
      setFilterAction(value);
    }
  };

  useEffect(() => {
    if (filterAction === "apply" || filterAction === "clean") {
      const timer = setTimeout(() => {
        onClose();
        setFilterAction("default");
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [filterAction]);

  const modalContent = (
    <DivFooterModalBackground>
      <DivFooterModal>
        <FlightDetailsModalHeaderMobile isVisible={isVisibleModal}>
          <Button
            onClick={handleIsVisible}
            icon={<FaArrowLeft />}
            color="white"
            size="ghost"
          />
          <div
            onClick={(e) => {
              if (!isVisibleModal) {
                e.stopPropagation();
              }
            }}
          >
            <FieldSearchMobile isVisible={isVisibleModal}>
              <FlightDetailsModalModalHeader>
                <IconContent />
                <InfoContent>
                  <Typography color={theme.colors.white} variant="h2">
                    Onde comprar
                  </Typography>
                  <Typography color={theme.colors.white} variant="label">
                    Detalhes do voo e aonde comprar.
                  </Typography>
                </InfoContent>
              </FlightDetailsModalModalHeader>
            </FieldSearchMobile>
          </div>
        </FlightDetailsModalHeaderMobile>
        <FlightDetailsModalModalContent
          id={"flight-details-modal-modal-content"}
        >
          {children}
        </FlightDetailsModalModalContent>
      </DivFooterModal>
    </DivFooterModalBackground>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};
